module.exports = ".problem-list-expansion-panel .mat-expansion-panel-header {\n  height: auto !important;\n  min-height: 48px; }\n"